import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";

export function useHiringReliability() {
  return useCbhFlag(CbhFeatureFlag.HIRING_RELIABILITY, {
    defaultValue: {
      enabled: false,
      penaltyMappers: {},
      maxLateCancellationHours: 12,
      graceWindowInMinutes: 10,
      bansCountLabelMapper: {},
      penaltyLabelMapper: {},
      autoBanCandidatesEnabled: false,
      simplifiedBanEnabled: false,
    },
  });
}
